/**
 * @generated SignedSource<<5d7f35897c1f125d7feb9d097f9d9882>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type tsShopConnectMutation$variables = {
  shop: string;
  token: string;
  secret: string;
};
export type tsShopConnectMutation$data = {
  readonly connectStore2: {
    readonly shops: ReadonlyArray<{
      readonly _id: number;
      readonly id: string;
      readonly shop: string;
      readonly v2: boolean;
    }>;
  };
};
export type tsShopConnectMutation = {
  variables: tsShopConnectMutation$variables;
  response: tsShopConnectMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "secret"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shop"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "token"
},
v3 = [
  {
    "kind": "Variable",
    "name": "secret",
    "variableName": "secret"
  },
  {
    "kind": "Variable",
    "name": "shop",
    "variableName": "shop"
  },
  {
    "kind": "Variable",
    "name": "token",
    "variableName": "token"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Shop",
  "kind": "LinkedField",
  "name": "shops",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shop",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "v2",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "tsShopConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "connectStore2",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "tsShopConnectMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "connectStore2",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2c031fbac00faf39223f733bf369b9ba",
    "id": null,
    "metadata": {},
    "name": "tsShopConnectMutation",
    "operationKind": "mutation",
    "text": "mutation tsShopConnectMutation(\n  $shop: String!\n  $token: String!\n  $secret: String!\n) {\n  connectStore2(shop: $shop, token: $token, secret: $secret) {\n    shops {\n      _id\n      id\n      shop\n      v2\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "84dacb900647dcf1e4b31ec35c34c639";

export default node;
